/**
 * Setup script to initialize Firestore for development
 * Run this after deploying rules and indexes
 */

import { seedTestData } from './seedData';

async function setup() {
  // eslint-disable-next-line no-console
  console.log('🚀 Starting Firestore setup...\n');

  // Get user ID from Firebase Auth
  const auth = (await import('../services/firebase')).auth;
  
  // Wait for auth to be ready
  await new Promise<void>((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        unsubscribe();
        resolve();
      }
    });
  });

  const user = auth.currentUser;
  if (!user) {
    // eslint-disable-next-line no-console
    console.error('❌ No authenticated user found. Please sign in first.');
    return;
  }

  // eslint-disable-next-line no-console
  console.log('✅ Authenticated as:', user.email);
  // eslint-disable-next-line no-console
  console.log('📝 User ID:', user.uid);
  // eslint-disable-next-line no-console
  console.log('');

  // Clean up old data first
  // eslint-disable-next-line no-console
  console.log('🧹 Cleaning up old data...');
  const { cleanupTestData } = await import('./cleanupData');
  await cleanupTestData(user.uid);

  // Seed test data
  // eslint-disable-next-line no-console
  console.log('📦 Seeding fresh test data...');
  const result = await seedTestData(user.uid);

  if (result.success) {
    // eslint-disable-next-line no-console
    console.log('\n✅ Setup complete!');
    // eslint-disable-next-line no-console
    console.log('🎉 You can now use the app with test data.');
  } else {
    // eslint-disable-next-line no-console
    console.error('\n❌ Setup failed:', result.error);
  }
}

// Auto-run if in development
declare global {
  interface Window {
    runSetup: typeof setup;
  }
}

if (import.meta.env?.DEV) {
  window.runSetup = setup;
  // eslint-disable-next-line no-console
  console.log('💡 Run window.runSetup() in console to seed test data');
}

export { setup };
